import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import styles from "@/asserts/styles/formSection.module.less";
import { useWatchProductionMaterial } from "../hooks/useWatchProductionMaterial";
import { useFormEditable } from "../hooks/useFormEditable";
import { useTranslation } from "react-i18next";

export function AttachmentFileFormFields() {
  const { t } = useTranslation("sourcingRequirementManagement");
  const { isProductionMaterial } = useWatchProductionMaterial();
  const { isMainFormDisabled: hiddenRemove } = useFormEditable();

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("相关附件")} />

      <div className={styles.sectionBody}>
        {isProductionMaterial ? (
          <>
            <MaterialFileFormFields
              label={t("现有标准物料文件")}
              fieldName="standardMaterialFiles"
              hiddenRemove={hiddenRemove}
            />
            <MaterialFileFormFields
              label={t("现有供应商COA")}
              fieldName="coaFiles"
              hiddenRemove={hiddenRemove}
            />
          </>
        ) : (
          <>
            <MaterialFileFormFields
              label={t("URS文件")}
              fieldName="ursFiles"
              hiddenRemove={hiddenRemove}
            />
          </>
        )}

        <MaterialFileFormFields
          label={t("其他")}
          fieldName="othersFiles"
          required={false}
          hiddenRemove={hiddenRemove}
        />
      </div>
    </div>
  );
}
